var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridUpload(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 140,
    viewBox: "0 0 316 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 140,
    fill: "#F6F7F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2909_87291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.812 50H142.626C140.075 50 138 52.0751 138 54.6256V63.8119C138 66.3624 140.075 68.4375 142.626 68.4375H151.812C154.362 68.4375 156.438 66.3624 156.438 63.8119V54.6256C156.438 52.0751 154.362 50 151.812 50ZM153.312 63.8119C153.312 64.6393 152.639 65.3125 151.812 65.3125H142.626C141.798 65.3125 141.125 64.6393 141.125 63.8119V54.6256C141.125 53.7982 141.798 53.125 142.626 53.125H151.812C152.639 53.125 153.312 53.7982 153.312 54.6256V63.8119Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.312 50H164.25C161.665 50 159.562 52.1028 159.562 54.6875V63.75C159.562 66.3347 161.665 68.4375 164.25 68.4375H173.312C175.897 68.4375 178 66.3347 178 63.75V54.6875C178 52.1028 175.897 50 173.312 50ZM174.875 63.75C174.875 64.6116 174.174 65.3125 173.312 65.3125H164.25C163.388 65.3125 162.688 64.6116 162.688 63.75V54.6875C162.688 53.8259 163.388 53.125 164.25 53.125H173.312C174.174 53.125 174.875 53.8259 174.875 54.6875V63.75Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.812 71.5625H142.626C140.075 71.5625 138 73.6376 138 76.1881V85.3744C138 87.9249 140.075 90 142.626 90H151.812C154.362 90 156.438 87.9249 156.438 85.3744V76.1881C156.438 73.6376 154.362 71.5625 151.812 71.5625ZM153.312 85.3744C153.312 86.2018 152.639 86.875 151.812 86.875H142.626C141.798 86.875 141.125 86.2018 141.125 85.3744V76.1881C141.125 75.3607 141.798 74.6875 142.626 74.6875H151.812C152.639 74.6875 153.312 75.3607 153.312 76.1881V85.3744Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.312 71.5625H164.25C161.665 71.5625 159.562 73.6653 159.562 76.25V85.3125C159.562 87.8972 161.665 90 164.25 90H173.312C175.897 90 178 87.8972 178 85.3125V76.25C178 73.6653 175.897 71.5625 173.312 71.5625ZM174.875 85.3125C174.875 86.1741 174.174 86.875 173.312 86.875H164.25C163.388 86.875 162.688 86.1741 162.688 85.3125V76.25C162.688 75.3884 163.388 74.6875 164.25 74.6875H173.312C174.174 74.6875 174.875 75.3884 174.875 76.25V85.3125Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2909_87291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(138 50)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridUpload);
export default __webpack_public_path__ + "static/media/GridUpload.4a96f3ea0685ae13e4e923713ca6d557.svg";
export { ForwardRef as ReactComponent };